export default __webpack_public_path__ + "static/media/blue-feather.98b2df7d.png";